import DragDropView from './dragdrop-view';

const view = new DragDropView();



// WEBPACK FOOTER //
// in/scripts/index.js